<template>
    <div>
        <h1 class="text-2xl font-bold">
            <template v-if="nom || prenom">
                {{$t('composants.sav-map-input.modifier_l_adresse')}}
            </template>
            <template v-else>
                {{$t('composants.sav-map-input.nouvelle_adresse')}}
            </template>
        </h1>

        <div class="p-4 rounded bg-orange-100 my-4 text-orange-700 text-xl font-bold">
            <i class="fas fa-exclamation-triangle mr-1"></i> {{ $tt('L\'adresse doit être correctement saisie, elle sera utilisée pour le renvoi de votre produit') }}
        </div>
        <div :class="displayMap ? 'lg:w-1/2' : 'w-full'">
            <!-- Prenom -->
            <div class="my-5">
                <div class="md:flex items-center" :class="errors.fName ? 'text-red-500 font-bold' : 'font-light'">
                    <div class="flex items-center mb-2 md:mb-0">
                        <i v-show="errors.fName" class="mr-2 fa-solid fa-circle-exclamation"></i>
                        <div class="text-lg">{{$t('composants.sav-map-input.mon_prenom_est')}} </div>
                    </div>
                    <input v-model="formValue.fName" type="text" class="w-full md:w-fit px-0 py-1 ml-3 text-lg font-bold text-black border-0 border-b grow focus:border-transparent focus:border-b-black focus:ring-0">
                </div>
                <div class="mt-1 text-sm font-light text-red-500" v-for="(error, errorIndex) in errors.fName" :key="'result-fname-' + errorIndex">
                    {{error}}
                </div>
            </div>
            <!-- Nom -->
            <div class="my-5">
                <div class="md:flex items-center" :class="errors.lName ? 'text-red-500 font-bold' : 'font-light'">
                    <div class="flex items-center mb-2 md:mb-0">
                        <i v-show="errors.lName" class="mr-2 fa-solid fa-circle-exclamation"></i>
                        <div class="text-lg">{{$t('composants.sav-map-input.mon_nom_est')}} </div>
                    </div>
                    <input v-model="formValue.lName" type="text" class="w-full md:w-fit px-0 py-1 ml-3 text-lg font-bold text-black border-0 border-b grow focus:border-transparent focus:border-b-black focus:ring-0">
                </div>
                <div class="mt-1 text-sm font-light text-red-500" v-for="(error, errorIndex) in errors.lName" :key="'result-lname-' + errorIndex">
                    {{error}}
                </div>
            </div>
            <!-- Pays -->
            <div class="my-5">
                <div class="flex items-center" :class="errors.country ? 'text-red-500 font-bold' : 'font-light'">
                    <i v-show="errors.country" class="mr-2 fa-solid fa-circle-exclamation"></i>
                    <div class="text-lg">{{$t('composants.sav-map-input.j_habite_en')}} </div>
                    <select v-model="formValue.country" class="w-40 p-2 ml-3 font-bold text-black border-gray-300 grow rounded-xl" test-id="country-address-input">
                        <option :value="country" v-for="(country, countryIndex) in countries" :key="'country-' + countryIndex">{{country.label}}</option>
                    </select>
                </div>
                <div class="mt-1 text-sm font-light text-red-500" v-for="(error, errorIndex) in errors.country" :key="'result-country-' + errorIndex">
                    {{error}}
                </div>
            </div>
            <!-- Adresse -->
            <div class="my-5" v-if="formValue.country">
                <div class="md:flex items" :class="errors.adresse ? 'text-red-500 font-bold' : 'font-light'">
                    <div class="flex items-center mt-1.5 mb-2 md:mb-0">
                        <i v-show="errors.adresse" class="mr-2 fa-solid fa-circle-exclamation"></i>
                        <div class="text-lg">{{$t('composants.sav-map-input.a_l_adresse')}} : </div>
                    </div>
                    <sav-address-input class="grow ml-3" :country="formValue.country.value" @get="selectAddress" />
                </div>
                <div class="mt-1 text-sm font-light text-red-500" v-for="(error, errorIndex) in errors.adresse" :key="'result-adresse-' + errorIndex">
                    {{error}}
                </div>
            </div>

            <button @click="saveAddress" class="px-5 py-2.5 text-sm font-base text-white duration-100 duration-200 bg-green-600 border-green-700 hover:bg-green-700 rounded-xl" test-id="btn-add-address">
                <i class="mr-1 fas fa-check"></i> {{$t('composants.sav-map-input.ajouter')}}
            </button>
        </div>
    </div>
</template>

<script>
import apiService from '@/services/api.service'

export default {
    props: {
        default: {
            type: String
        },
        nom: {},
        prenom: {},
        map: {
            type: Boolean,
            default: true
        },
    },
    watch: {
        // default: async function(value) {
        //     this.setDefaultData()
        // },

        // map: function(value) {
        //     this.displayMap = value
        // },
        // addressCountry: function(value) {
        //     this.results = []
        //     this.searchAddress()
        // }
    },

    data() {
        return {
            countries: [
                {
                    value: 'FR',
                    label: "France"
                },
                {
                    value: 'BE',
                    label: "Belgique"
                },
                {
                    value: 'CH',
                    label: "Suisse"
                },
                {
                    value: 'DE',
                    label: "Allemagne"
                },
                {
                    value: 'IT',
                    label: "Italie"
                },
                {
                    value: 'ES',
                    label: "Espagne"
                },
                {
                    value: 'GB',
                    label: "Angleterre"
                },
                {
                    value: 'AD',
                    label: "Andorre"
                },
                {
                    value: 'MC',
                    label: "Monaco"
                }
            ],
            timer: null,
            results: [],
            selectedAddress: null,
            selectedCountry: null,
            displayMap: false,
            formValue: {
                fName: '',
                lName: '',
                country: null,
                address: ''
            },
            firstName: '',
            lastName: '',
            errors: {}
        }
    },

    methods: {
        async setDefaultData() {
            let user = await apiService.getUser()
            this.formValue.fName = this.prenom ? this.prenom : user.prenom
            this.formValue.lName = this.nom ? this.nom : user.nom
        },

        selectAddress(address) {
            this.formValue.address = address
        },

        saveAddress() {
            let hasError = false
            // Prenom
            if (!this.formValue.fName) {
                this.errors = {...this.errors, fName: [this.$t('composants.sav-map-input.votre_prenom_est_obligatoire')]}
                hasError = true
            } else {
                this.errors['fName'] = null
            }

            // Nom
            if (!this.formValue.lName) {
                this.errors = {...this.errors, lName: [this.$t('composants.sav-map-input.votre_nom_est_obligatoire')]}
                hasError = true
            } else {
                this.errors['lName'] = null
            }

            // Pays
            if (!this.formValue.country) {
                this.errors = {...this.errors, country: [this.$t('composants.sav-map-input.vous_devez_selectionner_un_pays')]}
                hasError = true
            } else {
                this.errors['country'] = null
            }

            // Adresse
            if (this.formValue.country) {
                if (!this.formValue.address) {
                    this.errors = {...this.errors, adresse: [this.$t('composants.sav-map-input.vous_devez_ajouter_une_adresse')]}
                    hasError = true
                } else {
                    this.errors['adresse'] = null
                }
            }

            if (!hasError) {
                let ville = this.formValue.address.data.locality                
                if (!ville) {
                    this.formValue.address.data.address_components.forEach((item) => {
                        if (item.types.find((type) => type == 'sublocality')) {
                            ville = item.long_name
                        }
                    })
                }
                
                this.$emit('input', {
                    nom: this.formValue.lName,
                    prenom: this.formValue.fName,
                    // adresse1: this.formValue.address.address_components[0].long_name + ' ' + this.formValue.address.address_components[1].long_name,
                    // cp: this.formValue.address.address_components[6].long_name,
                    // ville: this.formValue.address.address_components[2].long_name,
                    // longitude: this.formValue.address.geometry.location.lng(),
                    // latitude: this.formValue.address.geometry.location.lat()
                    adresse1: (this.formValue.address.data.street_number || '') + ' ' + (this.formValue.address.data.route || ''),
                    adresse2: null,
                    cp: this.formValue.address.data.postal_code,
                    ville: ville,
                    longitude: this.formValue.address.data.longitude,
                    latitude: this.formValue.address.data.latitude
                })

                // this.address = {
                //     numero: data.street_number,
                //     rue: data.route,
                //     adresse1: (data.street_number || '') + ' ' + (data.route || ''),
                //     adresse2: '',
                //     cp: data.postal_code,
                //     ville: ville,
                //     longitude: data.longitude,
                //     latitude: data.latitude,
                //     pays: data.country,
                //     code_pays: shortCode.short_name,
                // }
            }
        }
    },

    async mounted() {
        this.setDefaultData()
    }
}
</script>



// WEBPACK FOOTER //
// src/components/SavMapInput.vue